import React, { useState, useEffect } from "react";
import {
  Table, Button, Modal, Form, Input, Row, Col, Card, notification, Space, Tag,Select,
} from "antd";
import {
  AppstoreAddOutlined,
  EditOutlined,
  DeleteOutlined,
} from "@ant-design/icons";

import DefaultLayout from "../../components/layout/DefaultLayout";
import Header from "../../components/header";
import taskReminder from "../../services/taskReminder";

import FormListComponent from "./../../components/serviceDeskFormList";
import userService from '../../services/user';


const TaskReminderGroup = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form] = Form.useForm();
  const [currentPage, setCurrentPage] = useState(1);
  const [totalDataCount, setTotalDataCount] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(15);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);

  const [formId, setFormId] = useState([]);
  const [users, setUsers] = useState([]);
  const [userIds, setUserIds] = useState([]);

  const getGroups = async (page = 1) => {
    setLoading(true);

    await taskReminder.getGroups().then((response) => {
      console.log('response', response)
      setData(response.data);
      setCurrentPage(page);
      setTotalDataCount(response.total);
      setItemsPerPage(response.per_page);
      setLoading(false);
    });
  };

  const getUsers = async () => {
    let response;
    response = await userService.getUsers();
    setUsers(response.data);
  };


  useEffect(() => {
    getGroups();
    getUsers();
  }, []);

  const handleDelete = (record) => {
    console.log(record);
    Modal.confirm({
      title: "Confirm Deletion",
      content: `Are you sure you want to delete the group: ${record.name}?`,
      onOk: async () => {
        setLoading(true);
        try {
          const response = await taskReminder.deleteGroup(record.id);
          if (response?.data || response?.message) {
            notification.success({
              message: "Group Deleted",
              description: response.message || `Group "${record.name}" has been deleted.`,
            });
            getGroups(currentPage);
          }
        } catch (error) {
          notification.error({
            message: "Error",
            description: error?.response?.data?.message || "Failed to delete the group.",
          });
        } finally {
          setLoading(false);
        }
      },
    });
  };

  const showModal = () => {
    setFormId(null);
    form.resetFields();
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setEditing(null);
    setFormId(null);
    form.resetFields();
  };

 const handleEdit = (record) => {
  console.log('edited record');
  console.log(record);

  setEditing(record);
  setIsModalVisible(true);

  const userIds = record.members.map((m) => m.user.id);
  setUserIds(userIds);

  form.setFieldsValue({
    name: record.name,
    user_ids: userIds,
  });
};


  const handleUserChange = (selectedValue) => {
    setUserIds(selectedValue);
  };

  const onFinish = async (values) => {
    setLoading(true);

    try {
      if (editing) {
        const response = await taskReminder.updateGroup(editing.id, values);
        if (response.data) {
          setIsModalVisible(false);
          setEditing(null);
          form.resetFields();
          notification.success({
            message: "Group Updated",
            description: `Group "${response.data.name}" has been updated.`,
          });
          getGroups(currentPage);
        }
      } else {
        const response = await taskReminder.postGroup(values);
        console.log('response submit', response);

        if (response.data) {
          setIsModalVisible(false);
          setEditing(null);
          form.resetFields();
          notification.success({
            message: "Group Added",
            description: `Group "${response.data.name}" has been added.`,
          });
          getGroups(currentPage);
        }
      }
    } catch (error) {
      notification.error({
        message: "Error",
        description: error?.response?.data?.message || "Something went wrong.",
      });
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      title: "Group Name",
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => a.name.localeCompare(b.name),
      //...getColumnSearchProps('name'),
    },
    {
      title: "Members",
      dataIndex: "members",
      key: "members",
      render: (members) => {
        const names = members.map((m) => m.user.name).join(", ");
        return <span>{names}</span>;
      },
    },
    {
      title: "Actions",
      key: "actions",
      fixed: "right",
      width: 80,
      render: (text, record) => (
        <Space>
          <div onClick={() => handleEdit(record)} style={{ cursor: "pointer" }}>
            <EditOutlined />
          </div>

          <div
            onClick={() => handleDelete(record)}
            style={{ cursor: "pointer" }}
          >
            <DeleteOutlined />
          </div>
        </Space>
      ),
    },
  ];

  return (
    <DefaultLayout>
      <Row gutter={[24, 24]}>
        <Col span={24}>
          <Header
            icon={<AppstoreAddOutlined />}
            title="Task Reminder Groups"
            right={
              <Button className="btn-blue" type="primary" onClick={showModal}>
                Add Group
              </Button>
            }
          />
        </Col>
      </Row>

      <Card>
        <Table
          scroll={{ x: 1000 }}
          style={{ minHeight: "100vh" }}
          columns={columns}
          dataSource={data.map((item) => ({ ...item, key: item.id }))}
          pagination={{
            total: totalDataCount,
            current: currentPage,
            pageSize: itemsPerPage,
            onChange: (page, pageSize) => getGroups(page),
          }}
          loading={loading}
        />
      </Card>

      <Modal
        title={editing ? "Edit Group" : "Add Group"}
        open={isModalVisible}
        onCancel={handleCancel}
        footer={null}
        width={650}
      >
        <Form
          form={form}
          onFinish={onFinish}
          layout="vertical"
          className="mt-20"
        >
          <Form.Item
            name="name"
            label="Group"
            rules={[{ required: true, message: "Please enter the Group" }]}
          >
            <Input size="large" placeholder="Type Group Name" />
          </Form.Item>
          <Form.Item
            name="user_ids"
            label="Members"
            rules={[{ required: true, message: "Please select Members" }]}
          >
            <Select
                mode="multiple"
                showSearch={true}
                optionFilterProp="children"
                style={{ width: '100%' }}
                size="large"
                allowClear
              >
                {users &&
                  users.map((user) => (
                    <Select.Option key={user.id} value={user.id}>
                      {user.name} - {user.email}
                    </Select.Option>
                  ))}
              </Select>
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" loading={loading}>
              {editing ? "Update Group" : "Add Group"}
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </DefaultLayout>
  );
};

export default TaskReminderGroup;